export const breakpoints = {
  phone: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 1023px)",
  tabletAndAbove: "(min-width: 768px)",
  mobile: "(max-width: 1023px)",
  desktop: "(min-width: 1024px)"
}